export default {
      id: "home-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#home-usage",
      toString: function () {
        return this.url;
      }
    }